import React from 'react';

import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import MeetingJoinOnAnotherDeviceCodes from './shared/MeetingJoinOnAnotherDeviceCodes';

type Props = {
    dialInNumber?: string;
    pin?: string;
    conferenceLink?: string;
    onClose: () => void;
};

/**
 * Pixel-matched prototype of the Figma "Suggestion" for the joining-info UX
 * (Meetings UX bug board): a small floating card anchored above the Meeting
 * Info panel rather than a centered BaseModal — the mockup keeps the video
 * and panel visible behind it instead of dimming the whole screen.
 *
 * The codes themselves are shared with the lobby's dialog; only this framing
 * is particular to being inside a meeting.
 */
const MeetingJoinOnAnotherDeviceModal = ({
    dialInNumber,
    pin,
    conferenceLink,
    onClose,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="shadow-base absolute end-[calc(var(--spacing-meeting-side-panel)-2.5rem)] top-4 z-30 flex flex-col gap-4 rounded-lg bg-white p-4 text-gray-900">
            <div className="flex items-center justify-between gap-8">
                <span className="text-base font-bold">
                    {i18next.t('videoconference.lobby.join_other_device')}
                </span>
                <button
                    className="flex cursor-pointer items-center border-none bg-transparent p-0"
                    onClick={onClose}
                    aria-label={i18next.t('close')}
                    type="button"
                >
                    <Icon iconKey="close" />
                </button>
            </div>

            <MeetingJoinOnAnotherDeviceCodes
                dialInNumber={dialInNumber}
                pin={pin}
                conferenceLink={conferenceLink}
            />
        </div>
    );
};

export default MeetingJoinOnAnotherDeviceModal;
